import React from 'react';

const CalendarExplanation = ({ isMobile = false }) => {
  if (isMobile) {
    return (
      <div className="mb-3 p-2 bg-morado/5 rounded-lg border border-morado/20">
        <div className="flex items-center gap-2">
          <span className="text-sm">📅</span>
          <div className="flex-1">
            <p className="text-xs text-gray-700">
              <strong>Número en círculo</strong> = tu energía del día. <strong>Colores + emojis</strong> = días especiales
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="mb-4 p-3 bg-morado/5 rounded-lg border border-morado/20">
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0 w-8 h-8 rounded-full bg-morado/10 flex items-center justify-center">
          <span className="text-sm">📅</span>
        </div>
        <div className="flex-1">
          <h4 className="text-sm font-semibold text-morado mb-1">¿Cómo leer el calendario?</h4>
          <p className="text-xs text-gray-700 leading-relaxed">
            Cada día muestra un <strong>número dentro del círculo</strong> que representa tu <strong>energía personal del día</strong>. 
            Los días con colores de fondo y emojis son <strong>días especiales</strong> con energías potenciadas que puedes aprovechar.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CalendarExplanation;
